/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AssetClass } from './AssetClass';
import {
    AssetClassFromJSON,
    AssetClassFromJSONTyped,
    AssetClassToJSON,
} from './AssetClass';
import type { AssetType } from './AssetType';
import {
    AssetTypeFromJSON,
    AssetTypeFromJSONTyped,
    AssetTypeToJSON,
} from './AssetType';
import type { SubAssetType } from './SubAssetType';
import {
    SubAssetTypeFromJSON,
    SubAssetTypeFromJSONTyped,
    SubAssetTypeToJSON,
} from './SubAssetType';

/**
 * 
 * @export
 * @interface BondCreateRequest
 */
export interface BondCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof BondCreateRequest
     */
    issuer?: string;
    /**
     * 
     * @type {string}
     * @memberof BondCreateRequest
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof BondCreateRequest
     */
    cusip: string;
    /**
     * 
     * @type {number}
     * @memberof BondCreateRequest
     */
    coupon?: number;
    /**
     * 
     * @type {string}
     * @memberof BondCreateRequest
     */
    maturityDate: string;
    /**
     * 
     * @type {string}
     * @memberof BondCreateRequest
     */
    issueDate?: string;
    /**
     * 
     * @type {number}
     * @memberof BondCreateRequest
     */
    length?: number;
    /**
     * 
     * @type {AssetClass}
     * @memberof BondCreateRequest
     */
    assetClass: AssetClass;
    /**
     * 
     * @type {AssetType}
     * @memberof BondCreateRequest
     */
    assetType: AssetType;
    /**
     * 
     * @type {SubAssetType}
     * @memberof BondCreateRequest
     */
    subAssetType?: SubAssetType;
    /**
     * 
     * @type {number}
     * @memberof BondCreateRequest
     */
    priceMultiplier: number;
    /**
     * 
     * @type {number}
     * @memberof BondCreateRequest
     */
    contractMultiplier: number;
}



/**
 * Check if a given object implements the BondCreateRequest interface.
 */
export function instanceOfBondCreateRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "cusip" in value;
    isInstance = isInstance && "maturityDate" in value;
    isInstance = isInstance && "assetClass" in value;
    isInstance = isInstance && "assetType" in value;
    isInstance = isInstance && "priceMultiplier" in value;
    isInstance = isInstance && "contractMultiplier" in value;

    return isInstance;
}

export function BondCreateRequestFromJSON(json: any): BondCreateRequest {
    return BondCreateRequestFromJSONTyped(json, false);
}

export function BondCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BondCreateRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'issuer': !exists(json, 'issuer') ? undefined : json['issuer'],
        'description': json['description'],
        'cusip': json['cusip'],
        'coupon': !exists(json, 'coupon') ? undefined : json['coupon'],
        'maturityDate': json['maturity_date'],
        'issueDate': !exists(json, 'issue_date') ? undefined : json['issue_date'],
        'length': !exists(json, 'length') ? undefined : json['length'],
        'assetClass': AssetClassFromJSON(json['asset_class']),
        'assetType': AssetTypeFromJSON(json['asset_type']),
        'subAssetType': !exists(json, 'sub_asset_type') ? undefined : SubAssetTypeFromJSON(json['sub_asset_type']),
        'priceMultiplier': json['price_multiplier'],
        'contractMultiplier': json['contract_multiplier'],
    };
}

export function BondCreateRequestToJSON(value?: BondCreateRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'issuer': value.issuer,
        'description': value.description,
        'cusip': value.cusip,
        'coupon': value.coupon,
        'maturity_date': value.maturityDate,
        'issue_date': value.issueDate,
        'length': value.length,
        'asset_class': AssetClassToJSON(value.assetClass),
        'asset_type': AssetTypeToJSON(value.assetType),
        'sub_asset_type': SubAssetTypeToJSON(value.subAssetType),
        'price_multiplier': value.priceMultiplier,
        'contract_multiplier': value.contractMultiplier,
    };
}

